import 'front-library/dist/main.css'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './style.css'

import { createPinia } from 'pinia'
import piniaPluginPersistedState from 'pinia-plugin-persistedstate'
import i18n from './i18n'

import { configureSentry } from './config/register-sentry'
import { registerGlobalComponents } from './register-global-components'

const pinia = createPinia()
pinia.use(piniaPluginPersistedState)
const app = createApp(App)
registerGlobalComponents(app)
configureSentry(app, router)
app.use(router).use(i18n).use(pinia).mount('#app')

document.body.addEventListener('plugin_web_update_notice', e => {
  const { version, options } = e.detail
})
